<template>
  <div class="info-card">
    <div class="warning-bar">
      <img
        class="warning-icon"
        src="https://pbs-public.oss-cn-shenzhen.aliyuncs.com/static-visa/pdv-wxa/interview/interview-notice/icon-warning-1.png"
      />
      <div class="warning-text">{{ interviewData.notice_remark }}</div>
    </div>

    <div class="info-label">
      <img
        class="info-icon"
        src="https://pbs-public.oss-cn-shenzhen.aliyuncs.com/static-visa/pdv-wxa/interview/interview-notice/icon-embassy.png"
      />
      <div class="info-text">赴馆信息</div>
      <div class="info-divider"></div>
      <div class="time-tips">{{ interviewData.time_remark }}</div>
    </div>

    <div class="interview-date">
      <div class="day-text">{{ interviewDate.day }}</div>
      <div class="time-text">{{ interviewDate.time }}</div>
    </div>

    <div class="embassy-box" @click="openMap">
      <div class="embassy-content">
        <div class="embassy-name">
          <div class="embassy-tag">使领馆</div>
          <div class="embassy-name-text">
            {{ embassyAddress.embassy_name || '' }}
          </div>
        </div>
        <div class="embassy-address">{{ addressText }}</div>
      </div>
      <div class="right-box">
        <div class="map-entry">
          <div class="map-icon-wrapper">
            <img
              class="map-icon"
              src="https://pbs-public.oss-cn-shenzhen.aliyuncs.com/static-visa/pdv-wxa/interview/interview-notice/icon-location.png"
            />
          </div>
          <div class="map-text">地图</div>
        </div>
      </div>
    </div>

    <div class="info-row">
      <div class="row-label">赴馆人员</div>
      <div class="row-value">{{ applicantNames }}</div>
    </div>

    <div v-if="interviewData.companion_name" class="info-row">
      <div class="row-label">陪签员</div>
      <div class="row-value companion">
        <div>{{ interviewData.companion_name }}</div>
        <a
          v-if="interviewData.companion_telephone"
          class="phone"
          href="javascript:void(0)"
          @click.stop.prevent="callPhone(interviewData.companion_telephone)"
        >
          <img
            class="phone-icon"
            src="https://pbs-public.oss-cn-shenzhen.aliyuncs.com/static-visa/pdv-wxa/interview/interview-notice/icon-phone.png"
          />
          <span>{{ interviewData.companion_telephone }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import util from '../../../services/tools';
import pcdService from '../../../services/pcdService';

export default {
  name: 'SectionInterviewInfo',
  props: {
    interviewData: {
      type: Object,
      default: () => ({}),
    },
    isWeixin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pcds: {},
    };
  },
  computed: {
    embassyAddress() {
      return this.interviewData.embassy_address || {};
    },
    applicantNames() {
      if (!this.interviewData || !this.interviewData.interview) return '';

      let applicantArray = [];
      this.interviewData.interview.forEach((item) => {
        if (Array.isArray(item.applicant)) {
          applicantArray = applicantArray.concat(item.applicant);
        } else if (item.applicant) {
          applicantArray.push(item.applicant);
        }
      });

      return applicantArray.join('、');
    },
    interviewDate() {
      if (!this.interviewData || !this.interviewData.interview_time) {
        return { day: '', week: '', time: '' };
      }

      const date = dayjs(this.interviewData.interview_time);
      return {
        day: date.format('YYYY年MM月DD日'),
        time: date.format('HH:mm'),
      };
    },
    addressText() {
      const embassyAddress = this.embassyAddress;
      const province =
        this.pcds[86] && embassyAddress.province_code
          ? this.pcds[86][embassyAddress.province_code] || ''
          : '';
      const city =
        this.pcds[embassyAddress.province_code] && embassyAddress.city_code
          ? this.pcds[embassyAddress.province_code][embassyAddress.city_code] ||
            ''
          : '';
      const county =
        this.pcds[embassyAddress.city_code] && embassyAddress.county_code
          ? this.pcds[embassyAddress.city_code][embassyAddress.county_code] ||
            ''
          : '';

      return `${province}${city}${county}${
        embassyAddress.detail_address || ''
      }`;
    },
  },
  created() {
    pcdService
      .getPcd()
      .then((pcds) => {
        this.pcds = pcds || {};
      })
      .catch(() => {});
  },
  methods: {
    callPhone(phone) {
      if (!phone) return;
      if (!this.isWeixin || window.WebViewJavascriptBridge) {
        util.getBridge.bind(util)((bridge) => {
          bridge.callHandler('callPhone', phone, () => {});
        });
        return;
      }
      window.location.href = `tel:${phone}`;
    },
    openMap() {
      const embassyAddress = this.embassyAddress;
      if (!embassyAddress.lat || !embassyAddress.lng) return;
      if (!this.isWeixin || window.WebViewJavascriptBridge) {
        util.getBridge.bind(util)((bridge) => {
          bridge.callHandler('openMap', 'hehe', () => {});
        });
        return;
      }

      window.open(
        `http://api.map.baidu.com/geocoder?location=${embassyAddress.lat},${embassyAddress.lng}&coord_type=bd09ll&output=html&src=webapp.piaopiao.idsp`,
      );
    },
  },
};
</script>

<style lang="less" scoped>
.info-card {
  box-sizing: border-box;
  padding: 12px;
  border-radius: 8px;
  background: #fff;

  .warning-bar {
    display: flex;
    align-items: flex-start;
    box-sizing: border-box;
    padding: 4px 6px;
    border-radius: 2px;
    color: #ff7012;
    background: linear-gradient(
      90deg,
      rgba(255, 112, 18, 0.08) 40%,
      rgba(255, 112, 18, 0) 100%
    );
  }

  .warning-icon {
    flex-shrink: 0;
    width: 14px;
    height: 14px;
    margin-right: 6px;
    margin-top: 1px;
  }

  .warning-text {
    flex: 1;
    color: #ff7012;
    font-size: 10px;
    line-height: 14px;
    word-break: break-all;
    white-space: pre-wrap;
  }

  .info-label {
    margin-top: 16px;
    display: flex;
    align-items: center;
    font-size: 12px;
    line-height: 16px;
  }

  .info-icon {
    width: 12px;
    height: 12px;
    margin-right: 4px;
  }

  .info-text {
    color: #333;
  }

  .info-divider {
    margin: 0 6px;
    width: 0.5px;
    height: 12px;
    background: #d8d8d8;
  }

  .time-tips {
    color: #a6a6a6;
  }

  .interview-date {
    margin-top: 6px;
    color: #333;
    font-size: 22px;
    line-height: 31px;
    font-weight: 500;
    display: flex;
    align-items: center;
  }

  .week-text {
    margin-left: 4px;
    padding: 0 5px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 0.5px solid #91999f;
    color: #333;
    font-size: 11px;
    line-height: 1;
    border-radius: 8px;
    font-weight: 400;
  }

  .time-text {
    margin-left: 5px;
  }

  .embassy-box {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    margin-top: 12px;
    padding: 10px;
    border-radius: 4px;
    background: url(https://pbs-public.oss-cn-shenzhen.aliyuncs.com/static-visa/ssqwxa/interview/interview-notice/info-bg.png)
      #fafbfc no-repeat center center / cover;
    border: 0.5px solid #e9eef2;
  }

  .embassy-content {
    flex: 1;
    overflow: hidden;
    min-width: 0;
    padding-right: 10px;
  }

  .embassy-name {
    display: flex;
    align-items: center;
  }

  .embassy-tag {
    flex-shrink: 0;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 4px;
    border-radius: 2px;
    background: #ff4b4d;
    color: #fff;
    font-size: 10px;
    line-height: 1;
  }

  .embassy-name-text {
    margin-left: 5px;
    color: #333;
    font-size: 12px;
    line-height: 1;
    font-weight: 500;
  }

  .embassy-address {
    margin-top: 4px;
    color: #a6a6a6;
    font-size: 12px;
    line-height: 17px;
    word-break: break-all;
  }

  .right-box {
    flex-shrink: 0;
    padding: 0 6px 0 16px;
    position: relative;
  }

  .right-box::after {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 0.5px;
    height: 40px;
    background: #e9eef2;
  }

  .map-entry {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .map-icon-wrapper {
    width: 21px;
    height: 21px;
    border-radius: 12px;
    border: 0.5px solid #e9eef2;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .map-icon {
    width: 12px;
    height: 12px;
  }

  .map-text {
    color: #333;
    font-size: 12px;
    line-height: 21px;
    text-align: center;
  }

  .info-row {
    display: flex;
    align-items: flex-start;
    margin-top: 12px;
    font-size: 12px;
    line-height: 21px;
  }

  .row-label {
    flex-shrink: 0;
    width: 70px;
    color: #666;
    margin-right: 10px;
  }

  .row-value {
    flex: 1;
    overflow: hidden;
    word-break: break-all;
    color: #333;
    font-weight: 500;
  }

  .companion {
    display: flex;
    align-items: center;
  }

  .phone {
    display: flex;
    align-items: center;
    margin-left: 12px;
    color: #2864d9;
    font-size: 12px;
    line-height: 1;
    font-weight: 400;
  }

  .phone-icon {
    width: 12px;
    height: 12px;
    margin-right: 4px;
  }
}
</style>
